// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4121":"f31c497f","6355":"325c84e1","6936":"63319190","7666":"6053dcb5","7782":"8f674883","9401":"449522a8"}[chunkId] + ".chunk.css";
};